import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import ColumnWidthMinimize from './ColumnWidthMinimize';
import JSDisplayValue from './JSDisplayValue';
import JSDisplayWidgetCollapsibleHeight from './JSDisplayWidgetCollapsibleHeight';

// works for ArrayOfObjects and Array of Arrays

const JSDisplayArrayOfObjects = (props) => {
  let arr = [];
  if (Array.isArray(props.val)) {
    arr = props.val;
  }
  /*
  let first_obj = {};
  if (js_utils.is_object(arr[0]) || Array.isArray(arr[0])) {
    first_obj = arr[0];
  }
  const first_obj_keys = Object.keys(first_obj);
  const cell_keys = first_obj_keys;
  */
  const cell_keys = js_utils.array_of_arrays_all_keys(arr);
  let jsxThCells = null;
  if (cell_keys.length > 0) {
    jsxThCells = cell_keys.map((k) => {
      const cell = k;
      return (
        <th key={k} className="frfr-js-display-array-of-objects__key"><span>{cell}</span></th>
      );
    });
  } else {
    jsxThCells = (<th></th>);
  }
  let jsxTableHeaderRow = (
    <tr>
      {jsxThCells}
    </tr>
  );
  let jsxTableRows = arr.map((row, index) => {
    let obj = {};
    if (js_utils.is_object(row) || Array.isArray(row)) {
      obj = row;
    }
    let jsxCells = cell_keys.map((k) => {
      let cell = obj[k];
      return (
        <td key={k} className="val"><JSDisplayValue val={cell} /></td>
      );
    });
    return (
      <tr key={index}>
        {jsxCells}
      </tr>
    );
  });
  return (
    <ColumnWidthMinimize>
      <div className="frfr-js-display-object-widget">
        <div className="frfr-js-display-object-widget__xi-header"><span className="frfr-js-display-object-widget__xi-header_title">array of objects (or AOA array of arrays)</span></div>
        <div className="frfr-js-display-object-widget__xi-body">

          <JSDisplayWidgetCollapsibleHeight initialCollapsed={props.initialCollapsed}>
            <table className="frfr-js-table uu-text-nowrap222">
              <thead className="sticky-thead">
                {jsxTableHeaderRow}
              </thead>
              <tbody>
                {jsxTableRows}
              </tbody>
            </table>
          </JSDisplayWidgetCollapsibleHeight>

        </div>
      </div>
    </ColumnWidthMinimize>
  );
};

export default JSDisplayArrayOfObjects;